type TractorDashboardIconProps = {
  className?: string;
};

export const TractorDashboardIcon = ({
  className,
}: TractorDashboardIconProps): React.ReactElement => (
  <svg
    id="tractors"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26.736 18.257"
  >
    <path
      id="Combined-Shape"
      d="M16.709,1.229H1.012V12.184a.638.638,0,0,1,.074,0H16.709Zm1.264,0V12.18h7.216V7.853a.593.593,0,0,0-.256-.489l-2.183-1.5a.632.632,0,0,1-.222-.269l-1.9-4.367ZM1.718,13.444v1.124h.559a3.017,3.017,0,0,1,.493-1.124Zm23.471,0h-1.7a3.017,3.017,0,0,1,.505,1.185h1.2Zm-6.584,0H7.652a3.017,3.017,0,0,1,.508,1.2H18.1A3.017,3.017,0,0,1,18.606,13.444ZM2.277,15.833H1.086A.632.632,0,0,1,.454,15.2V13.449H.35a.633.633,0,0,1-.6-.834q0-.03,0-.06V.6A.632.632,0,0,1,.38-.035H21.046a.632.632,0,0,1,.58.38l1.989,4.581,2.034,1.4a1.857,1.857,0,0,1,.8,1.532v7.408a.632.632,0,0,1-.632.632H23.967a3,3,0,0,1-5.838.016h-10a3,3,0,0,1-5.851-.076Zm18.769,1.124A1.757,1.757,0,1,0,19.311,15.2,1.746,1.746,0,0,0,21.046,16.957Zm-15.835,0A1.757,1.757,0,1,0,3.476,15.2,1.746,1.746,0,0,0,5.211,16.957Z"
      transform="translate(0.282 0.035)"
    />
  </svg>
);
